import { render, staticRenderFns } from "./PrepareProof.vue?vue&type=template&id=7892aad7&"
import script from "./PrepareProof.vue?vue&type=script&lang=js&"
export * from "./PrepareProof.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports